import { useTranslation } from "react-i18next";
import "./styles.scss";

const NoticeCard = ({
  backgroundColor,
  icon,
  headingText,
  headingValues = {},
  descriptionText,
  descriptionValues = {},
  containerStyle = {},
  contentStyle = {},
}) => {
  const { t } = useTranslation();

  return (
    <div
      className="notice-card"
      style={{
        ...containerStyle,
        backgroundColor: `var(--bs-${backgroundColor})`,
      }}
    >
      <div className="content-wrapper" style={{ ...contentStyle }}>
        {icon ? <img src={icon} alt="notice icon" /> : null}
        <div>
          {headingText ? (
            <p className="notice-card-heading">
              {t(headingText, { ...headingValues })}
            </p>
          ) : null}
          {descriptionText ? (
            <p className="notice-card-description">
              {t(descriptionText, { ...descriptionValues })}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default NoticeCard;
